<template>
  <filial-settings-view title="Печать и фискализация" category="print" hide-group-titles />
</template>

<script>
  import FilialSettingsView from '@/components/ui/crud/fields/filials/FilialSettingsView.vue'

  export default {
    name: 'PrintingFiscalSettings',
    components: { FilialSettingsView },
  }
</script>
